module.exports = "<div class=\"calendarBox\">\n  <div class=\"dateBox\">\n    <div class=\"month\" [textContent]=\"dateData.Date | date: 'MMMM'\"></div>\n    <div class=\"day\" [textContent]=\"dateData.Date | date: 'd'\">22</div>\n    <div class=\"year\" [textContent]=\"dateData.Date | date: 'y'\">2017</div>\n  </div>\n  <div class=\"textBlock\">\n    <div class=\"heading\" [textContent]=\"dateData.Topic\"></div>\n    <div class=\"content\" [textContent]=\"dateData.Content\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/calendarbox/calendarbox.component.html
// module id = 320
// module chunks = 1